import React from "react";
import MerchantStorePricing from "../views/MerchantStorePricing";
/** Renders the real Store Pricing Options UI against the local walkthrough API. */
export default function NzPricingWalkthroughShell() {
  return (
    <div data-testid="nz-pricing-walkthrough-shell">
      <MerchantStorePricing />
    </div>
  );
}
